import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { Router } from '@angular/router';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { take } from 'rxjs';
import { UserClerkService } from '../../core/user/user-clerk.service';

@Component({
  selector: 'app-my-account-header-portrait',
  standalone: true,
  imports: [CommonModule, FormsModule, NzIconModule, NzDropDownModule, NzAvatarModule],
  templateUrl: './my-account-header-portrait.component.html',
  styleUrl: './my-account-header-portrait.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MyAccountHeaderPortraitComponent {
  constructor(
    private router: Router,
    private userClerkService: UserClerkService
  ) {}

  portraitUrl = computed(() => {
    return this.userClerkService.portraitUrl();
  });

  onWalletClick() {
    this.router.navigate(['/history']);
  }

  onMyAccountClick() {
    this.router.navigate(['/my-account']);
  }

  onUsageBillingClick() {
    this.router.navigate(['/usage-billing']);
  }

  onLogoutClick() {
    this.userClerkService.signOut$().pipe(take(1)).subscribe();
  }
}
